export const WalkthroughSteps = [
  {
    key: "welcome",
    target: `#undefined`, // replaced on start
    content: "welcome",
    disableBeacon: true,
    placement: "center",
  },
  {
    key: "template",
    target: "#stack_menu_templates_button",
    content: "template",
    disableBeacon: true,
    placement: "top",
  },
  {
    key: "column",
    target: "#header_vertical_1",
    content: "column",
    disableBeacon: true,
    placement: "auto",
  },
  {
    key: "bullets",
    target: "#gridd_content",
    content: "bullets",
    disableBeacon: true,
    placement: "center",
  },
];

export default WalkthroughSteps;
